import { render, staticRenderFns } from "./EsyH1.vue?vue&type=template&id=646f048c&scoped=true"
import script from "./EsyH1.vue?vue&type=script&lang=ts"
export * from "./EsyH1.vue?vue&type=script&lang=ts"
import style0 from "./EsyH1.vue?vue&type=style&index=0&id=646f048c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646f048c",
  null
  
)

export default component.exports